import React from "react";

function PageNotFound(props) {
  return (
    <div className="container">
      <h1>PageNotFound</h1>
    </div>
  );
}

export default PageNotFound;
